import { useTranslation } from "react-i18next";
import React, { ReactNode, useState } from "react";
import { Modal } from "antd";

interface ScoreDetailModalProps {
  children?: ReactNode;
}

function ScoreDetailModal({ children }: ScoreDetailModalProps) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  const showModal = () => {
    setOpen(true);
  };

  const hideModal = () => {
    setOpen(false);
  };
  return (
    <div>
      <div onClick={showModal}>{children}</div>
      <Modal
        title={
          <span className="font-size-24 line-height-32 font-weight-6">
            {t("Bảng điểm chi tiết", "Bảng điểm chi tiết")}
          </span>
        }
        width={708}
        open={open}
        maskClosable={false}
        centered
        className="score-detail-modal"
        onCancel={hideModal}
      >
        <div className="score-detail-table">
          <div className="row score-table-header">
            <div className="cell">{t("Phần bài", "Phần bài")}</div>
            <div className="cell">{t("Tên phần", "Tên phần")}</div>
            <div className="cell">{t("Điểm số", "Điểm số")}</div>
          </div>
          <div className="row">
            <div className="cell">
              {t("Phần 05", "Phần 05")} <p>{t("(05 câu)", "(05 câu)")}</p>
            </div>
            <div className="cell font-weight-6">
              Figma ipsum component variant main layer?
            </div>
            <div className="cell">0.25/1.0</div>
          </div>
          <div className="row">
            <div className="cell">
              {t("Phần 05", "Phần 05")} <p>{t("(05 câu)", "(05 câu)")}</p>
            </div>
            <div className="cell font-weight-6">
              Figma ipsum component variant main layer?
            </div>
            <div className="cell">0.25/1.0</div>
          </div>
          <div className="row">
            <div className="cell">
              {t("Phần 05", "Phần 05")} <p>{t("(05 câu)", "(05 câu)")}</p>
            </div>
            <div className="cell font-weight-6">
              Figma ipsum component variant main layer?
            </div>
            <div className="cell">0.25/1.0</div>
          </div>
          <div className="row">
            <div className="cell">
              {t("Phần 05", "Phần 05")} <p>{t("(05 câu)", "(05 câu)")}</p>
            </div>
            <div className="cell font-weight-6">
              Figma ipsum component variant main layer?
            </div>
            <div className="cell">0.25/1.0</div>
          </div>
        </div>
      </Modal>
    </div>
  );
}

export default ScoreDetailModal;
